import script from "./CurrencySwitcher.vue?vue&type=script&lang=ts&setup=true"
export * from "./CurrencySwitcher.vue?vue&type=script&lang=ts&setup=true"

import "./CurrencySwitcher.vue?vue&type=style&index=0&id=7539adfe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7539adfe"]])

export default __exports__